import React from 'react';

export const LockIcon: React.FC<{ color?: string; size?: number | string }> = ({
	color,
	size,
}) => (
	<svg
		fill="none"
		height={size ?? '20'}
		viewBox="0 0 24 24"
		width={size ?? '20'}
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill={color}
			d="M6 8V7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7V8H20C20.5523 8 21 8.44772 21 9V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V9C3 8.44772 3.44772 8 4 8H6ZM19 10H5V20H19V10ZM11 15.7324C10.4022 15.3866 10 14.7403 10 14C10 12.8954 10.8954 12 12 12C13.1046 12 14 12.8954 14 14C14 14.7403 13.5978 15.3866 13 15.7324V18H11V15.7324ZM8 8H16V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V8Z"
		></path>
	</svg>
);
